import { type ComponentProps } from 'react';

import { Badge } from '@/components/Badge/Badge';
import { cn } from '@/util/utils';

/**
 * The provenance chip: where a field's value came from. A closed set with fixed labels,
 * deliberately not a general-purpose pill, and never a unit (units are input affixes).
 */
// eslint-disable-next-line react-refresh/only-export-components
export const STATE_CHIP_LABELS = {
    auto: 'auto',
    'on-create': 'on create',
    today: 'today',
    fixed: 'fixed',
    locked: 'locked',
} as const;

export type StateChipType = keyof typeof STATE_CHIP_LABELS;

type StateChipProps = Omit<ComponentProps<typeof Badge>, 'variant' | 'size' | 'children'> & {
    type: StateChipType;
};

function StateChip({ type, className, ...props }: StateChipProps) {
    return (
        <Badge
            data-slot="state-chip"
            data-type={type}
            variant="success"
            size="sm"
            // The design's state-chip is 6 across and 2 down, 18 tall: a size smaller than a sm
            // badge, so a chip inside a field row does not crowd the value (form.css .state-chip).
            className={cn('px-1.5 py-0.5', className)}
            {...props}
        >
            {STATE_CHIP_LABELS[type]}
        </Badge>
    );
}

export { StateChip };
